<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="FM-Head-fmh-2"><span href="#/xhtml/contents#ckey" title="Link target outside of Sample"><span class="ePub-B">Key Players</span></span></p>
<p class="List-Head-lh"><span class="ePub-B">The Dealers</span></p>
<p class="List-Unnum-ul-1">James “Brick” Feeney—cofounder of Pill City</p>
<p class="List-Unnum-ul-1">Willie “Wax” Harris—cofounder of Pill City</p>
<p class="List-Unnum-ul-1">Lamonta “Lyric” Johnson—BGF set leader</p>
<p class="List-Unnum-ul-1">Desmond “Damage” Vickers—BGF field marshal</p>
<p class="List-Unnum-ul-1">Dante “Slim” Robinson—BGF enforcer/dealer, Iraq War veteran</p>
<p class="List-Unnum-ul-1">Christopher “Train” Lockwood—BGF enforcer/dealer</p>
<p class="List-Unnum-ul-1">Jimmy Masters—leader of the Masters Organization, a Baltimore-based drug syndicate</p>
<p class="List-Unnum-ul-1">Ezekiel “Zeke” Masters—Jimmy’s younger brother, responsible for the family’s operations in Kansas City, Missouri</p>
<p class="List-Unnum-ul-1">Stephan “Stacks” Masters—Jimmy’s son, drug dealer</p>
<p class="List-Unnum-ul-1">Andrew “Blackrock” Masters—Jimmy’s son, responsible for the family’s operations in South Florida</p>
<p class="List-Unnum-ul-1">Kenny “Mondo” Mack—Jimmy’s nephew and security chief</p>
<p class="List-Unnum-ul-1">Lionel “Dome” Simmons—BGF enforcer</p>
<p class="List-Unnum-ul-1">Raheem Wallace—computer hacker, high-ranking member of the Youngstown Boys drug syndicate</p>
<p class="List-Head-lh"><span class="ePub-B">The Customers</span></p>
<p class="List-Unnum-ul-1">Keisha Jones—opiate addict, mother of a six-year-old boy</p>
<p class="List-Unnum-ul-1">Terry Augman—opiate addict, pregnant with her first child</p>
<p class="List-Unnum-ul-1">Derek Curry—opiate addict, former professional jazz guitarist</p>
<p class="List-Unnum-ul-1">Otis Washington—opiate addict, former sanitation worker</p>
<p class="List-Head-lh"><span class="ePub-B">The Investigators</span></p>
<p class="List-Unnum-ul-1">Frank Calvacca—Narcotics detective, Chicago Police Department</p>
<p class="List-Unnum-ul-1">Jamal Grayson—Narcotics detective, Baltimore Police Department</p>
<p class="List-Unnum-ul-1">Jeffrey Madigan—Gang detective, Newark Police Department</p>
<p class="List-Unnum-ul-1">Mike Malinowski—Sergeant, Baltimore Police Department</p>
<p class="List-Unnum-ul-1">Kirstin Marques—Special agent, Drug Enforcement Administration</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// key.vue?2f31a4ee